function nativeKeysIn(object){var result=[];if(null!=object)for(var key in Object(object))result.push(key);return result}module.exports=nativeKeysIn;